import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import fetchLandingPageContent from '../../common/actions/fetchLandingPageContent'
import { reportPageType } from '../../common/analytics'
import { IRootState } from '../../common/reducers'
import { IPageComponent } from '../../typings/pageComponent'
import LandingPage from '../pages/landing/landingPage'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  html: string
  css: string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { html, css } = state.landingPage

  return {
    html,
    css
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
) => {
  return {}
}

export type Props = IOwnProps & IStateProps

const createLandingPageContainer = (component: React.ComponentType<Props>) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  pageComponent.loadData = ({ store, location, apiAppUrlPrefix }) => {
    return store.dispatch(fetchLandingPageContent(location, apiAppUrlPrefix))
  }

  pageComponent.onBeforePageView = () => reportPageType('other')

  const container = connect<IStateProps, {}, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
  return container
}

export default createLandingPageContainer(LandingPage)
